import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  standalone: false,
  selector: 'pptl-app-availability',
  styleUrls: ['./modal-app-availability.component.scss'],
  templateUrl: './modal-app-availability.component.html',
})
export class ModalAppAvailabilityComponent {
  @Input()
  platformName: string;
  platformLink: string;

  constructor(private modalController: ModalController) {}

  onCancelButtonClick() {
    this.modalController.dismiss();
  }

  onOkButtonClick() {
    window.open(this.platformLink);
  }
}
